module.exports = __webpack_public_path__ + "img/TaxAddress1.7570cb52.jpg";